import { createSelector } from 'reselect';

import { selectedSchoolSelector } from '../../../reducers/selectors';

const hasSingleCampusSelector = createSelector(
  selectedSchoolSelector,
  school => school.campuses.length === 1,
);

export default hasSingleCampusSelector;
